import { useContext } from 'react';
import { ExplorerContext, ExplorerContextValue } from './explorer-context';

export function useExplorer(): ExplorerContextValue {
  const context = useContext(ExplorerContext);

  if (!context) {
    throw new Error('useExplorer debe utilizarse dentro de un Explorer.');
  }

  return context;
}
